"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabDescriptionForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const backoffice_1 = require("../../../dsl/backoffice");
/**
 * Simple Tab Description Form for ExpertsTab
 *
 * This component was created with the purpose of parsing
 * simple markdown for particular tab using get/set
 *
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
let TabDescriptionForm = class TabDescriptionForm extends vue_property_decorator_1.Vue {
    /**
     * Paragraph parsed from tag <br>
     */
    get tabText() {
        return this._tab.text.replace(/<br \/>/g, '\n');
    }
    /**
     * Paragraph parsed with tag <br>
     */
    set tabText(value) {
        this._tab.text = value.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }
};
__decorate([
    vue_property_decorator_1.PropSync('tab', { type: Object, required: true }),
    __metadata("design:type", Object)
], TabDescriptionForm.prototype, "_tab", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Number, required: true }),
    __metadata("design:type", Number)
], TabDescriptionForm.prototype, "index", void 0);
TabDescriptionForm = __decorate([
    vue_property_decorator_1.Component({
        name: 'TabDescriptionForm',
        components: {
            DashmixTextArea: backoffice_1.DashmixTextArea
        },
        template: `
    <div>
    <label :for="'tab-text-' + index" class="d-block">{{ $t('forms.experts.tabText.label') }}</label>
    <DashmixTextArea :model.sync="tabText" :name="'tab-text-' + index" :rows="2"
                     :placeholder="$t('forms.experts.tabText.placeholder')" />
    </div>
  `
    })
], TabDescriptionForm);
exports.TabDescriptionForm = TabDescriptionForm;
//# sourceMappingURL=TabDescriptionForm.js.map